'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import {
  Box,
  Fade,
  ScaleFade,
  Text,
  // keyframes,
  useDisclosure,
} from '@chakra-ui/react';

import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';

/**
 * Renders Contact Component
 * @param {Object} cardList - Data from api
 * @param {number} key - Get uniq id users
 * @param {function} handleHover - Get user id
 * @param {function} handleRemove - set the user Data api Call
 * @returns {ReactElement} - Contact Component
 */
const ArtsCard = ({
  cardList,
  key,
  handleHover,
  handleRemove,
  region,
  lang,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [samskritiApiData, setSamskritiApiData] = useState();
  const [active, setActive] = useState(-1);
  // const [flipCard, setFlipCard] = useState(0.7);
  const cardListApi = cardList.cards;
  const { isOpen, onToggle } = useDisclosure();
  // const spin = keyframes`
  //   from {transform: scaleX(1)}
  //   to {transform: scaleX(${flipCard})}
  // `;

  useEffect(() => {
    setSamskritiApiData(cardListApi);
  }, [cardListApi]);

  // const spinAnimation = `${spin} 2s linear`;

  const bgColors = [
    'rgba(30, 24, 5, 0.9)',
    'rgba(33, 5, 5, 0.9)',
    'rgba(17, 32, 5, 0.9)',
  ]; // Define an array of colors

  const [showText, setShowText] = useState(false);
  // const [hoverText, setHoverText] = useState(0);
  let timeoutId;

  const handleMouseEnter = () => {
    timeoutId = setTimeout(() => {
      setShowText(true);
    }, 400);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeoutId);
    // setHoverText(0);
    setShowText(false);
  };

  return (
    <>
      {samskritiApiData?.map((card, index) => {
        const isActive = active === index;
        return (
          <Box
            initialScale={0.9}
            animation={{
              base: isHovered && isActive,
              md: 'none',
            }}
            maxW="91.875rem"
            width={{
              base: '20.5rem',
              sm: '20.5rem',
              md: '23.528rem',
              lg: isActive ? '45.25rem' : '29.688rem',
              '2xl': isActive ? '45.25rem' : '29.688rem',
            }}
            height={{
              base: '433px',
              md: '450px',
              lg: '655px',
              '2xl': '824px',
            }}
            overflow="hidden"
            position="relative"
            key={key}
            cursor="pointer"
            onMouseEnter={() => {
              setIsHovered(true);
              handleHover(index);
              setActive(index);
              // setFlipCard(1);
              handleMouseEnter();
              onToggle();
            }}
            onMouseLeave={() => {
              setIsHovered(false);
              handleRemove();
              setActive(-1);
              // setFlipCard(0.7);
              handleMouseLeave();
              onToggle();
            }}
            transition="all 3s linear"
            sx={{ transition: 'all 0.4s linear' }}
          >
            <Box
              height={{
                base: '100%',
                md: '450px',
                lg: '655px',
                '2xl': '824px',
              }}
              width="100%"
              overflow="hidden"
              position="relative"
              backgroundImage={`url(${card.thumbnail.url})`}
              backgroundSize="cover" // or "fill" based on your design
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
              filter={
                isHovered && !isActive ? 'grayscale(100%)' : 'grayscale(0%)'
              }
              zIndex="0"
              transition="filter 1s linear"
              alt={card.thumbnail.alt} // Accessibility description
            >
              {/* <Box
              height={{
                base: '100%',
                md: '450px',
                lg: '655px',
                '2xl': '824px',
              }}
              // maxW="91.875rem"
              width="100%"
              overflow="hidden"
              position="relative"
            >
              <Image
                src={card.thumbnail.url}
                alt={card.thumbnail.alt}
                w="full"
                h="full"
                zIndex="0"
                // objectFit={{ base: 'cover', lg: 'fill', xl: 'cover' }}
                // transition="all 1s linear"
                filter={
                  isHovered && !isActive ? 'grayscale(100%)' : 'grayscale(0%)'
                }
              /> */}

              {!isHovered && (
                <Box
                  w="100%"
                  backgroundColor="rgba(1, 5, 9, 0.86)"
                  display={isHovered && isActive ? 'none' : 'flex'}
                  alignItems="center"
                  justifyContent="space-between"
                  position="absolute"
                  bottom="0"
                  maxH={{ base: '84px', md: '100%' }}
                  right="0"
                  zIndex="1"
                  p={{ base: 5, md: 4, lg: 6 }}
                  transition="all 1s linear"
                >
                  <Text
                    color="#FFFFFF"
                    letterSpacing="0.16px"
                    fontFamily="var(--FedraSansStd-medium)"
                    fontSize={{
                      base: '1.125rem',
                      lg: '1.665625rem',
                      '2xl': '2.25rem',
                    }}
                    fontWeight="500"
                    textTransform="uppercase"
                    lineHeight={{
                      base: '1.8rem',
                      lg: '2.665rem',
                      '2xl': '3.6rem',
                    }}
                  >
                    {card.title}
                  </Text>

                  <Link
                    href={refineUrlDomain(card.buttonLink, region, lang)}
                    textAlign="left"
                    prefetch
                  >
                    <ChevronRightIcon w={8} h={8} color="white" />
                  </Link>
                </Box>
              )}
            </Box>
            <ScaleFade
              initialScale={1}
              in={isHovered && isActive}
              transition={{ exit: { delay: 1 }, enter: { duration: 0.2 } }}
            >
              {isHovered && isActive && (
                <Box
                  in={isOpen}
                  cursor="default"
                  // in={isOpen}
                  position="absolute"
                  bottom="0"
                  left="0"
                  right="0"
                  p="4"
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  backgroundColor={bgColors[index]}
                  color="white"
                  zIndex="1"
                  w="full"
                  height={{
                    base: '433px',
                    md: '450px',
                    lg: '655px',
                    '2xl': '824px',
                  }}
                >
                  <Fade
                    in={showText && isHovered}
                    transition={{
                      exit: { delay: 1 },
                      enter: { duration: 1 },
                    }}
                  >
                    <StructuredTextParser
                      str={render(card.description.value)}
                      fontFamily="var(--FedraSansStd-book)"
                      fontSize={{
                        base: '0.875rem',
                        md: '1.125rem',
                        lg: '1.375rem',
                      }}
                      color="#fff7e9"
                      lineHeight={{ base: '1.5rem', lg: '2.2rem' }}
                      textAlign="center"
                      width={{ base: '100%', lg: '75%' }}
                      m="0 auto!important"
                      // sx={{
                      //   transition: showText && 'all 1.2s ease-in',
                      // }}
                      // transform={`scale(${!hoverText})`}
                    />
                  </Fade>
                </Box>
              )}
            </ScaleFade>
          </Box>
        );
      })}
    </>
  );
};

export default ArtsCard;
